import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, verifytoken } from '../../../services/ApiCallingUserServices';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import CustomTable from '../../../customControl/CustomTable';
import { ClearLocalStorage } from '../../commonClass/Session';
import CommonFilter from '../../../customControl/CommonFilter';


const Userlist = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userlist, setUserList] = useState([]);
    const [filteritems, setFilterItems] = useState([]);
    const [searchby, setSerachBy] = useState('All');
    const [searchvalue, setSearchValue] = useState();
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const getuserdatalist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const usrdata = await getAllData('/auth/v1/getadminuserlist?UserType=' + 0)
            setUserList(usrdata.data);
            setFilterItems(usrdata.data)
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const columns = [
        {
            name: 'Sr No.',
            sortable: true,
            float: "left",
            selector: (user) => user?.sqnNo,
        },
        {
            name: 'Name',
            key: 'fullName',
            sortable: true,
            float: "left",
            selector: (user) => user?.fullName,
        },
        {
            name: 'Gender',
            key: 'gender',
            sortable: true,
            float: "left",
            selector: (user) => user?.gender,
        },
        {
            name: 'Department',
            key: 'departmentName',
            sortable: true,
            float: "left",
            selector: (user) => user?.departmentName,
        },
        {
            name: 'Role',
            key: 'roleName',
            sortable: true,
            float: "left",
            selector: (user) => user?.roleName,
        },
        {
            name: 'Email',
            key: 'userEmail',
            sortable: true,
            float: "left",
            selector: (user) => user?.userEmail,
        },
        {
            name: 'Mobile Number',
            key: 'contactNo',
            sortable: true,
            float: "left",
            selector: (user) => user.contactNo,
        },
        {
            name: 'Edit',
            selector: user => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEdit(user.userMasterID)}></i></button>
        }
    ];

    useEffect(() => {
        getuserdatalist();
    }, [])

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });

    }, [user])

    const handleOpen = () => {
        navigate('/Useradd', { state: { disabled: false, editdisabled: false, viewtype: 'Add', Id: 0 } });
    }

    const handleEdit = (id) => {
        dispatch(loaderActions.start());
        let Id = 0;
        userlist?.map((obj) => {
            Id = obj.userMasterID;
        });
        navigate('/Useradd', { state: { disabled: false, editdisabled: true, viewtype: 'Update', Id: id } });
    }

    const ExportToExcel = () => {
        const dispalyname = ['Sr No', 'Name', 'Gender', 'Department', 'Role', 'Email', 'Mobile Number'];
        const fields = ['sqnNo', 'fullName', 'gender', 'departmentName', 'roleName', 'userEmail', 'contactNo'];
        ExportExcel(dispalyname, fields, userlist, "UserList", "UserList.xls");
    }
    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>User List</h3>
            </div>
            <div className="container-fluid form_border pt-5 my-3">
                <form action="" >
                    <div className="d-flex justify-content-start ms-lg-3">
                        <button type="button" disabled={!useradd} className="btn btn-primary mx-1" to="Suppliermaster" id="btnAdd" onClick={handleOpen} >Create New User</button>
                    </div>
                    <br />
                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        // searchDisabled={serchdisable}
                        getdata={getuserdatalist}
                        setlistdata={setUserList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        className={"user_role"}
                        columns={columns}
                        data={userlist}
                        PdfExport={false}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default Userlist